import React from 'react';
import PropTypes from 'prop-types';
import {injectIntl, IntlShape} from 'react-intl';
import {getLocale} from '../basicLocales';
import {ASCENDING} from './Grid.react';

import './Grid.scss';

interface HeaderCellProps {
 column?: string;
 columnMetadata?: unknown[];
 columnObject: object;
 content?: any;
 entity?: any;
 firstLevelTypes?: boolean;
 intl?: object;
}

// TODO test for all kinds of current tables
class HeaderCell extends React.Component<HeaderCellProps> {
    static propTypes = {
        column: PropTypes.string,
        columnMetadata: PropTypes.array,
        columnObject: PropTypes.object.isRequired,
        content: PropTypes.any,
        entity: PropTypes.any,
        firstLevelTypes: PropTypes.bool,
        intl: PropTypes.object,
    };

    static defaultProps = {
        firstLevelTypes: false
    };

    getText(locale) {
        let {columnObject, columnMetadata, entity} = this.props;

        let type;

        if (this.props.firstLevelTypes) {
            type = columnMetadata[columnMetadata.length - 1];
        }
        else {
            type = columnMetadata.length >= 2 ? columnMetadata[columnMetadata.length - 2] : columnMetadata[columnMetadata.length - 1];
        }

        let parentType = columnMetadata.length >= 2 ? columnMetadata[columnMetadata.length - 3] : columnMetadata[columnMetadata.length - 2];

        let translationKey = parentType ? parentType.to().entity() : entity;

        if ('name' in columnObject && columnObject.name) {
            if (typeof columnObject.name === 'string') {
                return {"text": columnObject.name};
            }

            return {"text": columnObject.name[locale]};
        }

        if (type && type.shortName) {

            if (type.name) {
                return {
                    "text": type.shortName,
                    "title": type.title || type.name,
                };
            } else {
                return {
                    "text": type.shortName,
                };
            }

        }

        if (type && type.name) {
            return {
                "text": this.props.intl.formatMessage({defaultMessage: type.name, id: "metadata." + translationKey + "." + type.key})
            };
        }

        return {"text": ""};
    }

    getClassName() {
        let {columnObject} = this.props;

        if ('className' in columnObject) {
            return columnObject.className;
        }

        return null;
    }

    render() {
        let {column, columnObject} = this.props;
        let text;

        if (this.props.content) {
            text = {
                text: this.props.content
            };
        }
        else {
            text = this.getText(getLocale());
        }

        const thStyle = {
            ...(columnObject.width ? {width: columnObject.width + '%'} : {}),
            ...(columnObject.onHeaderClick ? {cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap'} : {}),
        };

        return (
            <th className={this.getClassName()} key={"header_" + column} onClick={columnObject.onHeaderClick} style={thStyle} title={text.title}>
                {text.text}
                {columnObject.sortIcon ?
                    <span>&nbsp;{columnObject.sortIcon}</span>
                    : null
                }
                {columnObject.sorting ?
                    <span>&nbsp;<i className={"fa fa-sort-alpha-" + (columnObject.sorting === ASCENDING ? 'asc' : 'desc')}></i></span>
                    : null
                }
            </th>
        );
    }
}
export default injectIntl(HeaderCell);
